import { render, staticRenderFns } from "./chuanggj.vue?vue&type=template&id=d48c040c&scoped=true"
import script from "./chuanggj.vue?vue&type=script&lang=js"
export * from "./chuanggj.vue?vue&type=script&lang=js"
import style0 from "./chuanggj.vue?vue&type=style&index=0&id=d48c040c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d48c040c",
  null
  
)

export default component.exports